export default __webpack_public_path__ + "152da048cdabac7d60bada8fa6143b73.png";